import { environment } from '../environments/environment';

export const AppConfig = {
  ...environment,
  defaultAvatar: 'assets/img/svg/logo_circle.svg',
  appVersion: '0.1.2',
};
